import * as React from "react";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

// UI-only form for creating/updating an allowance record.
export default function AllowanceFormModal({
  open,
  onClose,
  mode = "add", // "add" | "edit"
  initialValues = {}
}) {
  const isEdit = mode === "edit";
  const { showToast } = useToast();

  const handlePrimaryClick = () => {
    showToast({
      message: isEdit ? "Allowance updated" : "Allowance created",
      severity: "success"
    });
    if (onClose) onClose();
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handlePrimaryClick}>
        {isEdit ? "Update" : "Create"}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isEdit ? "Edit Allowance" : "Add Allowance"}
      actions={actions}
      maxWidth="sm"
      fullWidth
    >
      <Box className="modal-form-grid modal-form-grid--spaced">
        {/* Condo Company */}
        <Box className="modal-form-row">
          <FormControl fullWidth required size="small">
            <InputLabel>Condo Company</InputLabel>
            <Select
              defaultValue={initialValues.condoCompany || "Caspo"}
              label="Condo Company"
            >
              <MenuItem value="Caspo">Caspo</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Condo Unit */}
        <Box className="modal-form-row">
          <FormControl fullWidth required size="small">
            <InputLabel>Condo Unit</InputLabel>
            <Select
              defaultValue={initialValues.condoUnit || "Three Central - 28F Three Central"}
              label="Condo Unit"
            >
              <MenuItem value="Three Central - 28F Three Central">Three Central - 28F Three Central</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Amount with PHP prefix */}
        <Box className="modal-form-row" display="flex" gap={1}>
          <Box display="flex" alignItems="center" px={0.5}>
            <Typography variant="body2">PHP</Typography>
          </Box>
          <TextField
            fullWidth
            required
            size="small"
            type="number"
            label="Amount"
            placeholder="0.00"
            defaultValue={initialValues.amountValue || "8750.00"}
            inputProps={{ step: "0.01" }}
          />
        </Box>

        {/* Payment Date - Month and Year */}
        <Box className="modal-form-row" display="flex" gap={1}>
          <FormControl fullWidth required size="small">
            <InputLabel>Payment Month</InputLabel>
            <Select
              defaultValue={initialValues.paymentMonth || "September"}
              label="Payment Month"
            >
              <MenuItem value="January">January</MenuItem>
              <MenuItem value="February">February</MenuItem>
              <MenuItem value="March">March</MenuItem>
              <MenuItem value="April">April</MenuItem>
              <MenuItem value="May">May</MenuItem>
              <MenuItem value="June">June</MenuItem>
              <MenuItem value="July">July</MenuItem>
              <MenuItem value="August">August</MenuItem>
              <MenuItem value="September">September</MenuItem>
              <MenuItem value="October">October</MenuItem>
              <MenuItem value="November">November</MenuItem>
              <MenuItem value="December">December</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth required size="small">
            <InputLabel>Payment Year</InputLabel>
            <Select
              defaultValue={initialValues.paymentYear || "2020"}
              label="Payment Year"
            >
              <MenuItem value="2019">2019</MenuItem>
              <MenuItem value="2020">2020</MenuItem>
              <MenuItem value="2021">2021</MenuItem>
              <MenuItem value="2022">2022</MenuItem>
              <MenuItem value="2023">2023</MenuItem>
              <MenuItem value="2024">2024</MenuItem>
              <MenuItem value="2025">2025</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Payment To / Condo Sharing */}
        <Box className="modal-form-row" display="flex" gap={1}>
          <TextField
            fullWidth
            required
            size="small"
            label="Payment To"
            defaultValue={initialValues.paymentTo || ""}
          />
          <FormControl fullWidth required size="small">
            <InputLabel>Condo Sharing</InputLabel>
            <Select
              defaultValue={initialValues.condoSharing || "Not Shared"}
              label="Condo Sharing"
            >
              <MenuItem value="Not Shared">Not Shared</MenuItem>
              <MenuItem value="Shared">Shared</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Remarks */}
        <TextField
          fullWidth
          multiline
          rows={3}
          size="small"
          className="modal-form-row"
          label="Remarks"
          defaultValue={initialValues.remarks || ""}
        />
      </Box>
    </Modal>
  );
}
